export function launchShopifyOAuth(authorizationUrl) {
  const url = new URL(authorizationUrl);
  const isShopifyAuthorize = url.protocol === "https:" &&
    url.hostname.endsWith(".myshopify.com") &&
    url.pathname === "/admin/oauth/authorize";

  if (!isShopifyAuthorize) {
    throw new Error("Invalid Shopify authorization URL");
  }

  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url.toString();
      return;
    }
  } catch {
    window.open(url.toString(), "_top");
    return;
  }

  window.location.assign(url.toString());
}